<template>
  <v-container fluid grid-list-md text-xs-center style="min-height: 93.4vh">
    <v-layout row wrap>
      <v-toolbar scroll-target="#scrolling-home" style="z-index: 1" extended>
        <v-toolbar-title v-show="!$vuetify.breakpoint.xsOnly"
          >Reporte de temperaturas de tutores</v-toolbar-title
        >
          <v-toolbar-title v-show="!$vuetify.breakpoint.xsOnly" style="margin-left: 960px;">
            <v-btn icon to="../reports">  
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-title>
        <v-speed-dial
          key="1"
          v-model="buttonFab.fab"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0;"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-model="buttonFab.fab"
                  style=" z-index:99"
                  color="gradiente"
                  dark
                  fab
                  :small="$vuetify.breakpoint.xsOnly"
                  v-on="on"
                >
                  <v-icon>add</v-icon>
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <span>Más Opciones</span>
            </v-tooltip>
          </template>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="exportToPDF"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
            <span>Descargar PDF</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
            >
              <JsonCSV
                class   = "btn btn-default"
                name    = "ReporteDeTemperaturaTutores.csv"
                :data="json_data"
                :labels="labels"
                :fields="fields"
                >
                <v-img
                  height="25px"
                  width="25px"
                  :src="require('@/assets/reports/IconoCSV.png')">
                </v-img>

              </JsonCSV>
              
            </v-btn>
            <span>Descargar CSV</span>
          </v-tooltip>
        </v-speed-dial>

        <template v-slot:extension>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4 lg2 offset-sm2 offset-lg1>
              <v-menu
                v-model="modalF"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    id="first"
                    :value="momentFormatFirst"
                    label="Fecha de inicio"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  header-color="primary"
                  color="secondary"
                  locale="es-419"
                  v-model="timeFirst"
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 md4 lg2>
              <v-menu
                v-model="modalL"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="momentFormatLast"
                    id="last"
                    label="Fecha de término"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  header-color="primary"
                  color="secondary"
                  locale="es-419"
                  v-model="timeLast"
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 class="titleSearch">
              <v-text-field
                flat
                label="Buscar"
                append-outer-icon="search"
                clearable
                solo-inverted
                hide-details
                @click:append-outer="filterSearch(false)"
                @click:clear="filterSearch(true)"
                @keyup.enter="filterSearch(false)"
                v-model="search"
              />
            </v-flex>
          </v-layout>
        </template>
      </v-toolbar>
      <v-container
        elevation-2
        fluid
        id="scrolling-activity"
        style="max-height: 75vh"
        class="table-full"
      >
        <v-layout row wrap>
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :rows-per-page-items="[10, 15, 25]"
              rows-per-page-text="Registros por página"
              :items="entries"
              :loading="working.wEntries"
              :pagination.sync="pagination"
              item-key="id"
              no-results-text="No se encontraron coincidencias"
              no-data-text="No hay registros"
              class="entries-table"
            >
              <template v-slot:headers>
                <tr>
                  <th
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    Nombres
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    Apellidos
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 400px; max-width: 400px; min-width: 400px"
                  >
                    Correo electrónico
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 210px; max-width: 210px; min-width: 210px"
                  >
                    Fecha/Hora
                  </th>
                  <th style="width: 210px; max-width: 210px; min-width: 210px">
                    <v-select
                      :items = temperaturas
                      multiple
                      outline
                      @change="filterTemp"
                      v-model="filters.temp"
                      height="50"
                      full-width
                    >
                      <template v-slot:label>
                        <span class="grey--text">Temperatura</span>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <span
                          v-if="index === filters.temp.length-1"
                          class="grey--text caption"
                        >( {{ "+"+filters.temp.length+" filtro"+(filters.temp.length>1 ? "s":"") }} )</span>
                      </template>
                    </v-select>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr v-bind:class="props.item.isNew ? 'new-entry' :  props.item.temperature  > 37.4 ? 'danger': ''">
                  <td
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    {{ props.item.firstName }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    {{ props.item.lastName }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 400px; max-width: 400px; min-width: 400px"
                  >
                    {{ props.item.email }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 210px; max-width: 210px; min-width: 210px"
                  >
                    {{ props.item.createdAt | formatDate }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 210px; max-width: 210px; min-width: 210px"
                  >
                    {{ props.item.temperature || temperature }}
                  </td>
                </tr>
              </template>
              <template v-slot:pageText="props">
                {{ props.pageStart }} - {{ props.pageStop }} de
                {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>

    <loading v-model="working.wLoading" text="Trabajando" />
    <success v-model="toast.success" text="Operación exitosa" />
    <error v-model="toast.failed" text="Ups ocurrió un error" />
  </v-container>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import loading from "../../Dialogs/Loading";
import success from "../../Dialogs/Success";
import error from "../../Dialogs/Error";
import jsPDF from "jspdf";
import JsonCSV from 'vue-json-csv'

export default {
  components: {
    loading,
    success,
    error,
    JsonCSV,
  },
  data: () => ({
    pagination: {
      sortBy: "name",
    },
    buttonFab: {
      fab: false,
      hidden: false
    },
    filters: {
      search: "",
      temperature: []
    },
    modalF: false,
    modalL: false,
    timeFirst: moment().format("YYYY-MM-DD"),
    timeLast: moment().format("YYYY-MM-DD"),
    entries: [],
    temperaturas: [],
    json_data: [],
    labels: {
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo Electrónico',
      role: 'Rol',
      createdAt: 'Fecha/Hora',
      temperature: 'Temperatura'
    },
    fields: ['firstName', 'lastName', 'email', 'role', 'createdAt', 'temperature'],
    search: "",
    toast: {
      success: false,
      failed: false,
    },
    working: {
      wEntries: false,
      wLoading: false,
    },
    headers: [
    ],
    connected: false,
  }),
  filters: {
    temperature: function (value) {
      if (isNaN(value)) {
        return "N/A";
      }
      return value.toFixed(1) + " ºC";
    },
  },
  methods: {
    filterSearch(clean) {
      if (clean) {
        this.filters.search = "";
      } else {
        this.filters.search = this.search ? this.search : "";
      }

      if (!this.working.wLoading) {
        this.getEntries();
      }
    },
    exportToPDF() {
      var self = this;
      this.callApi(function (items) {
        self.createEntriesPDF(self.timeFirst, self.timeLast, items);
      }, true);
    },
    getEntries() {
      var self = this;
      this.callApi(function (items) {
        self.entries = items;
      });
    },
    callApi(callback, ignorePagination) {
      this.working.wEntries = true;
      var offset = (this.pagination.page - 1) * this.pagination.rowsPerPage;
      var params = {};

      if (!ignorePagination) {
        params.page = this.pagination.rowsPerPage;
        params.offset = offset;
      }

      if (this.timeFirst) {
        params.from = this.timeFirst;
      }
      if (this.timeLast) {
        params.to = this.timeLast;
      }
      if (this.filters.search) {
        params.search = this.filters.search;
      }
      if (this.filters.temp) {
        params.temperatures = this.filters.temp
      }

      this.$store
        .dispatch("reports/getParentEntriesReport", params)
        .then((response) => {
          this.working.wEntries = false;
          this.json_data = response.data.items;
          callback(response.data.items);
          this.createEntriesCSV();
        })
        .catch((error) => {
          this.toast.failed = true;
          this.working.wEntries = false;
          console.log(error);
        });
    },
    createEntriesCSV(){
      this.dataCSV = this.json_data;
      for (let index = 0; index < this.json_data.length; index++) {
        this.json_data[index].createdAt = moment(this.json_data[index].createdAt).format("YYYY-MM-DD HH:mm:ss")
      }
    },
    createEntriesPDF(from, to, data) {
      var branch = this.getBranch;
      var doc = new jsPDF("p", "pt");

      var header = function (data) {
        var y = 40;
        doc.setFont("helvetica");
        doc.setFontType("bold");
        doc.setFontSize(25);

        if (branch.img != null && branch.img != "") {
          var imgData =
            branch.img == null ? "" : "data:image/jpg;base64, " + branch.img;
          doc.addImage(imgData, "JPEG", data.settings.margin.left, y, 100, 100);
        }

        var title = "Colegio " + branch.name;
        var splitTitle = doc.splitTextToSize(title, 400);
        for (var i in splitTitle) {
          doc.text(splitTitle[i], 150, (y += 25));
        }

        doc.setFont("helvetica");
        doc.setFontSize(13);
        doc.text("Reporte de temperatura", 150, (y += 25));

        var splitAddress = doc.splitTextToSize(branch.address, 400);
        for (var i in splitAddress) {
          doc.text(splitAddress[i], 150, (y += 15));
        }

        doc.text("Periodo: " + from + " -- " + to, 150, (y += 15));
      };

      var headers = [
        "Nombres",
        "Apellidos",
        "Correo electrónico",
        "Fecha/Hora",
        "Temperatura",
      ];

      var bodyTable = data.map(function (item) {
        return [
          item.firstName,
          item.lastName,
          item.email,
          moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss"),
          item.temperature ? item.temperature.toFixed(1) + " ºC" : "---",
        ];
      });

      doc.autoTable({
        head: [headers],
        body: bodyTable,
        margin: {
          top: 180,
        },
        styles: {
          fontSize: 10,
          verticalcell: 60,
          cellWidth: "grid",
        },
        didDrawPage: header,
      });
      doc.save("ReporteDeTemperatura.pdf");
    },
    getRoomID(idBranch) {
      return idBranch + "-parent-entries";
    },
    subscribeWs() {
      if (!this.connected && this.getBranch && this.getBranch.id) {
        var room = this.getRoomID(this.getBranch.id);
        console.log("Connecting & subscribing to ", room);
        this.$socket.connect();
        this.$socket.emit("subscribe", room);
        this.connected = true;
      } else {
        console.log("No branch yet");
      }
    },
    getTemps(){
      this.$store
        .dispatch("reports/getTempsStudents")
        .then((response) => {
          this.temperaturas = response.data
        })
        .catch((error) => {
          console.log(error);
        });
    },
    filterTemp(val) {
      if (!this.loading) {
        this.getEntries();
      }
    },
  },
  mounted() {
    this.getEntries();
    this.subscribeWs();
    this.getTemps();
  },
  beforeDestroy() {
    var room = this.getRoomID(this.getBranch.id);
    console.log('Unsubscribe from', room);
    this.$socket.emit("unsubscribe", room);
  },
  sockets: {
    connect(evt) {
      console.log("Connected", evt);
    },
    disconnect(evt) {
      console.log("Disconnected", evt);
    },
    reconnect() {
      console.log("Reconnected");
      this.subscribeWs();
    },
    message(notification) {
      var from = this.timeFirst
          ? moment(this.timeFirst, "YYYY-MM-DD")
              .hour(0)
              .minute(0)
              .second(0)
              .millisecond(0)
          : undefined,
        to = this.timeLast
          ? moment(this.timeLast, "YYYY-MM-DD")
              .hour(23)
              .minute(59)
              .second(59)
              .millisecond(999)
          : undefined,
        createdAt = moment(notification.createdAt);

      if (from && from.isAfter(createdAt)) {
        return;
      }

      if (to && to.isBefore(createdAt)) {
        return;
      }

      if (this.filters.search) {
        var pattern = "^.*" + this.filters.search + ".*";
        var regex = RegExp(pattern, "i");
        if (!regex.test(notification.firstName) && !regex.test(notification.lastName)) {
          return;
        }
      }

      if (this.entries) {
        notification.isNew = true;
        this.entries.unshift(notification);
      } else {
        this.entries = [notification];
      }

      var self = this;
      setTimeout(function() {
        var item = self.entries.find(function(el) {
          return el.id === notification.id;
        });

        if (item) {
          item.isNew = false;
        }
      }, 3500);
    },
  },
  watch: {
    getUser() {
      if (this.entries.length <= 0) {
        this.getEntries();
      }
    },
    getBranch() {
      this.subscribeWs();
    },
    timeFirst() {
      this.getEntries();
    },
    timeLast() {
      this.getEntries();
    },
  },
  computed: {
    momentFormatFirst() {
      if (this.timeFirst != null) {
        return moment(this.timeFirst).format("DD/MM/YYYY");
      }
      return "";
    },
    momentFormatLast() {
      if (this.timeLast != null) {
        return moment(this.timeLast).format("DD/MM/YYYY");
      }
      return "";
    },
    ...mapGetters(["getUser", "getBranch"]),
  },
};
</script>

<style>
.titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}

.new-entry {
  animation: difuminar 3s 1;
}

.danger{
  background-color: #f5bcc0;
}

@keyframes difuminar {
    0% {
        background-color: rgba(143, 188, 143, 1);
    }
    100% {
        background-color: rgba(143, 188, 143, 0);
    }
}
</style>
<style scoped>
/deep/ .table-full .v-datatable.v-table > tbody {
  max-height: calc(100vh - 426px);
  min-height: calc(100vh - 426px);
}
</style>
